/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';

import {AngularModalService} from '../common/modal/angular-modal.service';
import {ReviewRejectModalComponent} from './review-reject-modal.component';

export interface ReviewRejectModalOptions {
  reviewItem: any;
  creative: any;
  onComplete?: () => void;
}

@Injectable({providedIn: 'root'})
export class ReviewRejectModalService {
  constructor(private readonly angularModalService: AngularModalService) {
  }

  open(options: ReviewRejectModalOptions): void {
    this.angularModalService.show(ReviewRejectModalComponent, {
      initialState: options
    });
  }

  createRejectHandler(list: any): (reviewItem: any, creative: any) => void {
    return (reviewItem: any, creative: any) => {
      this.open({
        reviewItem,
        creative,
        onComplete: () => {
          list.makeQuery?.();
        }
      });
    };
  }
}
